import { Component, Input, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.pug',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  @Input() billingFlow:any
  year;
  constructor(private permissions: PermissionsService) { }
  ngOnInit(): void {
    this.year = new Date().getFullYear()
  }

}
